import React, { useContext, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  FormContext,
  FormNumberField,
  FormSelect,
  FormTextField,
  useStaticListSource,
} from '@eas/common-web';
import { EsFileRegulation } from '@models';
import { RegulationEntityType } from '@enums';
import { RegulationFieldProps } from './regulation-field';

export function RegulationDetailDialog({
  regulationTypes,
  regulationEntityTypes,
}: RegulationFieldProps) {
  const regulationTypeSource = useStaticListSource(regulationTypes);
  const regulationEntityTypeSource = useStaticListSource(regulationEntityTypes);

  const { setFieldValue, getFieldValues } = useContext(FormContext);

  useEffect(() => {
    const values: EsFileRegulation = getFieldValues();
    if (values.type === RegulationEntityType.ARTICLE) {
      setFieldValue('sectionOrArticlePart', values.article);
    } else if (values.type === RegulationEntityType.PARAGRAPH) {
      setFieldValue('sectionOrArticlePart', values.sectionSign);
    }
  }, []);

  return (
    <>
      <FormSelect
        name="regulationType"
        source={regulationTypeSource}
        valueIsId={true}
        label={
          <FormattedMessage
            id="ES__REGULATIONS_TOOLBAR__COLUMN__REGULATION_TYPE"
            defaultMessage="Typ"
          />
        }
      />
      <FormNumberField
        name="number"
        label={
          <FormattedMessage
            id="ES__REGULATIONS_TOOLBAR__COLUMN__NUMBER"
            defaultMessage="Číslo"
          />
        }
      />
      <FormNumberField
        name="year"
        label={
          <FormattedMessage
            id="ES__REGULATIONS_TOOLBAR__COLUMN__YEAR"
            defaultMessage="Rok"
          />
        }
      />
      <FormSelect
        name="type"
        source={regulationEntityTypeSource}
        valueIsId={true}
        label={
          <FormattedMessage
            id="ES__REGULATIONS_TOOLBAR__COLUMN__TYPE"
            defaultMessage="Typ"
          />
        }
      />
      <FormTextField
        name="sectionOrArticlePart"
        label={
          <FormattedMessage
            id="ES__REGULATIONS_TOOLBAR__COLUMN__SECTION_OR_ARTICLE_PART"
            defaultMessage="§ / Čl."
          />
        }
      />
      <FormTextField
        name="paragraph"
        label={
          <FormattedMessage
            id="ES__REGULATIONS_TOOLBAR__COLUMN__PARAGRAPH"
            defaultMessage="Odstavec"
          />
        }
      />
      <FormTextField
        name="letter"
        label={
          <FormattedMessage
            id="ES__REGULATIONS_TOOLBAR__COLUMN__LETTER"
            defaultMessage="Písmeno"
          />
        }
      />
      <FormTextField
        name="name"
        label={
          <FormattedMessage
            id="ES__REGULATIONS_TOOLBAR__COLUMN__NAME"
            defaultMessage="Název"
          />
        }
      />
      <FormTextField
        name="order"
        label={
          <FormattedMessage
            id="ES__REGULATIONS_TOOLBAR__COLUMN__ORDER"
            defaultMessage="Index (#)"
          />
        }
      />
    </>
  );
}
